export default __webpack_public_path__ + "static/media/Chess.d77a8771.jpg";